import React, { useState, useEffect, useReducer } from "react";
import { Row, Col, Card, Typography, Button, message, Divider, Tooltip, Form, Modal, Select, Space, Tag } from "antd";
import {
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
  UnorderedListOutlined,
  UserOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import { TableCustom } from "../../../components/table";
import { reducerRegister } from "../../../helpers/reducers";
import { getCampaignByIdApi } from "../../../api/formsColaboradoresCampaigns";
import { getAllActiveSectorsApi } from "../../../api/setores";
import { getAllActiveRolesApi } from "../../../api/cargos";
import { searchCollaboratorsApi } from "../../../api/colaboradores";
import {
  createReleaseFormApi,
  deleteReleaseFormApi,
  getAllReleaseFormsApi,
} from "../../../api/formsColaboradoresReleaseForms";
const { Text } = Typography;

const options_sectors_positions = [
  { value: 1, label: "Todos" },
  { value: 2, label: "Personalizado" },
  { value: 3, label: "Nenhum" },
];

const rules = {
  todos_setores: [{ required: true, message: "Selecione uma opção!" }],
  todos_cargos: [{ required: true, message: "Selecione uma opção!" }],
  id_cad_cargos: [{ required: true, message: "Selecione uma opção!" }],
  id_cad_setores: [{ required: true, message: "Selecione uma opção!" }],
};

export const FormulariosColaboradoresCampanhasFormularios = () => {
  const navigate = useNavigate();
  const { id_campanhas } = useParams();
  const [form] = Form.useForm();
  const [messageApi, contextMessage] = message.useMessage();
  const todos_cargos = Form.useWatch("todos_cargos", form);
  const todos_setores = Form.useWatch("todos_setores", form);
  const [loading, setLoading] = useState(false);
  const [dados, dispatch] = useReducer(reducerRegister, []);
  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();
  const [campanha, setCampanha] = useState({});
  const [collaborators, setCollaborators] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    if (id_campanhas) {
      getCampaignById(id_campanhas);
      getAllReleaseForms(id_campanhas);
      getSectors();
      getRoles();
      searchCollaborators();
    }
  }, [id_campanhas]);

  const getCampaignById = async (id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await getCampaignByIdApi(id);
      if (statusCode === 200) {
        if (!response.data) {
          navigate("/formularios-colaboradores/campanhas");
        }
        setCampanha(response.data);
      } else {
        message.error(response.message);
        navigate("/formularios-colaboradores/campanhas");
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
      navigate("/formularios-colaboradores/campanhas");
    } finally {
      setLoading(false);
    }
  };

  const getSectors = async () => {
    setLoading(true);
    try {
      const { statusCode, response } = await getAllActiveSectorsApi();
      if (statusCode === 200) {
        let array_sectors = [];
        for (const el of response.data) {
          array_sectors.push({ value: el.id, label: `${el.codigo_filial} - ${el.filial} - ${el.descricao}` });
        }
        setSectors(array_sectors);
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const getRoles = async () => {
    setLoading(true);
    try {
      const { statusCode, response } = await getAllActiveRolesApi();
      if (statusCode === 200) {
        let array_roles = [];
        for (const el of response.data) {
          array_roles.push({ value: el.id, label: el.descricao });
        }
        setRoles(array_roles);
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const searchCollaborators = async (search = "") => {
    try {
      const { response, statusCode } = await searchCollaboratorsApi(search);
      if (statusCode === 200) {
        let array_options = [];
        for (const el of response.data) {
          array_options.push({ value: el.id, label: `${el.matricula} - ${el.nome}` });
        }
        setCollaborators(array_options);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    }
  };

  const getAllReleaseForms = async (id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await getAllReleaseFormsApi(id);
      if (statusCode === 200) {
        dispatch({ type: "LOAD", payload: response?.data });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const createReleaseForms = async (data) => {
    setLoading(true);
    messageApi.open({
      key: "gerar_formulario",
      type: "loading",
      content: "Gerando formulários...",
      duration: 0,
    });

    try {
      const { statusCode, response } = await createReleaseFormApi(data);
      if (statusCode === 200) {
        messageApi.open({
          key: "gerar_formulario",
          type: "success",
          content: "Formulários Gerados!",
          duration: 2,
        });
        setShowModal(false);
        resetForm();
        getAllReleaseForms(id_campanhas);
      } else {
        message.error(response.message);
        messageApi.open({
          key: "gerar_formulario",
          type: "error",
          content: response?.message,
          duration: 2,
        });
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
      messageApi.open({
        key: "gerar_formulario",
        type: "error",
        content: "Ops, houve algum erro!",
        duration: 2,
      });
    } finally {
      setLoading(false);
    }
  };

  const deleteReleaseForm = async (id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await deleteReleaseFormApi(id);
      if (statusCode === 200) {
        message.success("Registro deletado com sucesso!");
        dispatch({ type: "DELETE", payload: { id: id } });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    form.resetFields();
  };

  const columns = [
    {
      title: "Colaborador",
      dataIndex: "colaborador",
    },
    {
      title: "Formulário",
      dataIndex: "formulario",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 100,
      render: (_, e) => (e.status === 1 ? <Tag color="green">Finalizado</Tag> : <Tag color="orange">Aguardando</Tag>),
      renderText: (e) => (e.status === 1 ? "Finalizado" : "Aguardando"),
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      width: 50,
      sorter: false,
      render: (_, e) =>
        campanha.status === 0 &&
        e.status === 0 && (
          <Space.Compact>
            <Button
              danger
              loading={loading}
              icon={<DeleteOutlined />}
              onClick={() => {
                modal.confirm({
                  title: "Deseja deletar este registro?",
                  okText: "Sim",
                  cancelText: "Cancelar",
                  onOk() {
                    deleteReleaseForm(e.id);
                  },
                });
              }}
            />
          </Space.Compact>
        ),
    },
  ];

  const onSubmit = (formData) => {
    formData.id_campanhas = id_campanhas;
    formData.id_colaborador = formData.id_colaborador ?? [];
    formData.id_cad_setores = formData.id_cad_setores ?? [];
    formData.id_cad_cargos = formData.id_cad_cargos ?? [];
    createReleaseForms(formData);
  };

  const modalFormulario = (
    <Modal
      title={
        <Text style={{ fontSize: 20 }}>
          <EditOutlined /> Adicionar Formulários Colaboradores
        </Text>
      }
      open={showModal}
      onOk={() => form.submit()}
      okText="Salvar"
      width={1200}
      okButtonProps={{ size: "large", loading: loading }}
      cancelButtonProps={{ size: "large", loading: loading }}
      onCancel={() => {
        setShowModal(false);
        resetForm();
      }}>
      <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Divider orientation="left">
            <AppstoreOutlined /> Setor e Cargo
          </Divider>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="todos_setores" label="Setores" rules={rules.todos_setores}>
              <Select
                showSearch
                size="large"
                placeholder="Selecione uma opção"
                disabled={loading}
                options={options_sectors_positions}
              />
            </Form.Item>
          </Col>
          {todos_setores === 2 && (
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="id_cad_setores" label="Selecione os Setores" rules={rules.id_cad_setores}>
                <Select
                  mode="multiple"
                  showSearch
                  optionFilterProp="label"
                  size="large"
                  placeholder="Selecione os setores"
                  disabled={loading}
                  options={sectors}
                />
              </Form.Item>
            </Col>
          )}

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="todos_cargos" label="Cargos" rules={rules.todos_cargos}>
              <Select
                showSearch
                size="large"
                placeholder="Selecione uma opção"
                disabled={loading}
                options={options_sectors_positions}
              />
            </Form.Item>
          </Col>

          {todos_cargos === 2 && (
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="id_cad_cargos" label="Selecione os Cargos" rules={rules.id_cad_cargos}>
                <Select
                  mode="multiple"
                  showSearch
                  size="large"
                  optionFilterProp="label"
                  placeholder="Selecione os cargos"
                  disabled={loading}
                  options={roles}
                />
              </Form.Item>
            </Col>
          )}

          <Divider orientation="left">
            <UserOutlined /> Colaborador
          </Divider>
          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="id_colaborador" label="Colaborador">
              <Select
                showSearch
                size="large"
                mode="multiple"
                placeholder="Selecione o colaborador"
                disabled={loading}
                options={collaborators}
                onSearch={(e) => searchCollaborators(e)}
                filterOption={false}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario}
      {contextHolder}
      {contextMessage}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage
              title="Formulários Colaboradores"
              onClickBack={() => navigate("/formularios-colaboradores/campanhas")}
            />
            <HeaderTitle
              title={["Campanhas", "Colaboradores"]}
              subtitle={`Campanha - ${campanha?.descricao ?? ""}`}
              icon={<UnorderedListOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom
                extraHeaderComponents={
                  <Tooltip title="Adicionar Registro">
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        setShowModal(true);
                        resetForm();
                      }}
                      loading={loading}>
                      Novo
                    </Button>
                  </Tooltip>
                }
                loading={loading}
                columns={columns}
                dataSource={dados}
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
